export default function Spinner({ label = 'Loading' }) {
  return (
    <div role="status" aria-label={label} className="flex items-center justify-center py-16">
      <span className="h-8 w-8 animate-spin rounded-full border-[3px] border-line border-t-brand" />
      <span className="sr-only">{label}</span>
    </div>);

}